import React from "react";
import "../styles/hero.css";

import {
  FaArrowRight,
  FaCheckCircle,
  FaChartLine,
  FaGasPump,
  FaPrint,
} from "react-icons/fa";

import dashboard from "../assets/images/nozel-dashboard.png";

const Hero = () => {
  return (
    <section className="hero" id="home">
      {/* Background */}
      <div className="hero-bg"></div>

      <div className="hero-shape hero-shape-1"></div>
      <div className="hero-shape hero-shape-2"></div>
      <div className="hero-shape hero-shape-3"></div>

      <div className="hero-container">
        {/* LEFT */}

        <div className="hero-content">
          <span className="hero-badge">
            COMPLETE PETROL PUMP TECHNOLOGY
          </span>

          <h1>
            Complete Fuel Station
            <br />
            Automation Solutions
          </h1>

          <p>
            Modern software and hardware solutions for Petrol Pumps including
            Accounts ERP, Nozzle Automation, Fuel Receipt Printing, External
            Display Systems and Complete Technical Support.
          </p>

          <div className="hero-checks">
            <div>
              <FaCheckCircle />
              Live Nozzle Monitoring
            </div>

            <div>
              <FaCheckCircle />
              Tank Stock Management
            </div>

            <div>
              <FaCheckCircle />
              Profit & Loss Reports
            </div>

            <div>
              <FaCheckCircle />
              Computerized Fuel Slips
            </div>
          </div>

          <div className="hero-buttons">
            <button className="primary-btn">
              Request Demo
            </button>

            <button className="secondary-btn">
              Our Solutions

              <FaArrowRight />
            </button>
          </div>

          <div className="hero-clients">
            Trusted by Fuel Stations across Pakistan
          </div>
        </div>

        {/* RIGHT */}

        <div className="hero-image-area">
          {/* Floating Card */}

          <div className="floating-card top-card">
            <FaChartLine />

            <div>
              <h4>ERP Reports</h4>

              <span>Live Financial Reports</span>
            </div>
          </div>

          {/* Dashboard */}

          <div className="dashboard-card">
            <img
              src={dashboard}
              alt="Dashboard"
            />
          </div>

          {/* Bottom Cards */}

          <div className="bottom-cards">
            <div className="mini-card">
              <FaGasPump />

              <div>
                <h5>Live Sales</h5>

                <span>Real Time</span>
              </div>
            </div>

            <div className="mini-card">
              <FaPrint />

              <div>
                <h5>Fuel Slips</h5>

                <span>Auto Printing</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Statistics */}

      <div className="hero-stats">
        <div className="stat-box">
          <h2>100+</h2>

          <span>Clients</span>
        </div>

        <div className="stat-box">
          <h2>250+</h2>

          <span>Projects</span>
        </div>

        <div className="stat-box">
          <h2>500+</h2>

          <span>Nozzles Connected</span>
        </div>

        <div className="stat-box">
          <h2>24/7</h2>

          <span>Support</span>
        </div>
      </div>

      {/* Scroll */}

      <div className="scroll-down">
        <span></span>
      </div>
    </section>
  );
};

export default Hero;